import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCircleUser, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import './MobileMenu.scss'
import MobileMenuPop from './MobileMenuPop';
const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  



  return (
    <div className='mobile-menu'>
         {isOpen ?<FontAwesomeIcon icon={faTimes} className="menu-icon" onClick={()=>setIsOpen(false)} /> :<FontAwesomeIcon icon={faBars} className="menu-icon" onClick={()=>setIsOpen(true)}  />}
         <MobileMenuPop isOpen={isOpen} setIsOpen={setIsOpen}/>
    </div>
  );
};

export default MobileMenu;